<template>
  <div>
    <cube-form
      :model="model"
      :options="options"
      @validate="validateHandler"
      @submit.prevent="submitHandler"
      @reset="resetHandler"
    >
      <cube-form-item :field="fields[0]" />
      <captcha-input
        v-model="model.captcha"
      />
      <div class="cube-form-item-box">
        <cube-form-item :field="fields[1]" />
        <div class="find-pwd-box">
          <get-code
            class="find-pwd-link"
            :mobile="model.mobile"
            :imgcaptcha="model.captcha"
            type="7"
            :is-disabled="false"
          />
        </div>
      </div>
      <cube-form-item :field="fields[2]" />
      <cube-form-item :field="fields[3]" />
      <div class=" form-btn-box form-btn-box2">
        <cube-button
          type="reset"
          :light="true"
        >
          {{ $t('message["896"]') }}
        </cube-button>
        <cube-button
          type="submit"
          :disabled="!isDisabled"
          :primary="true"
        >
          {{ $t('message["915"]') }}
        </cube-button>
      </div>
    </cube-form>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import GetCode from '@/components/mobile/GetCode'
import CaptchaInput from '@/components/mobile/CaptchaInput'

export default {
  components: {
    GetCode,
    CaptchaInput
  },
  data () {
    return {
      value: 'qq',
      options: {
        scrollToInvalidField: true,
        layout: 'classic' // classic fresh
      },
      validity: {},
      valid: undefined,
      model: {
        mobile: '',
        checkcode: '',
        captcha: '',
        newpassword: '',
        renewpassword: ''
      },
      fields: [
        {
          type: 'input',
          modelKey: 'mobile',
          label: '',
          props: {
            placeholder: this.$t('message["801"]')
          },
          rules: {
            required: true,
            type: 'tel'
          }
        },
        {
          type: 'input',
          modelKey: 'checkcode',
          label: '',
          props: {
            placeholder: this.$t('message["824"]')
          },
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'newpassword',
          label: '',
          props: {
            placeholder: this.$t('message["816"]'),
            type: 'password'
          },
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'renewpassword',
          label: '',
          props: {
            placeholder: this.$t('message["891"]'),
            type: 'password'
          },
          rules: {
            required: true,
            repeatValid: (val) => {
              return val === this.model.newpassword
            }
          },
          messages: {
            repeatValid: this.$t('message["608"]')
          }
        }
      ]
    }
  },
  computed: {
    ...mapState('account/login', ['submitting', 'decorators']),
    isDisabled () {
      return this.model.mobile && this.model.checkcode
    }
  },
  methods: {
    ...mapActions('account/login', ['login']),
    async submitHandler (e) {
      const obj = Object.assign(this.model, { type: 1 })
      this.$emit('submitForm', obj)
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
    },
    resetHandler () {
      this.$router.replace({ name: 'AccountLogin' })
    }
  }
}
</script>
<style lang="scss" scoped>
  .form-btn-box2 {
     position: static;
  }
</style>
